import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { fonts, borderRadius } from "../../tokens";
import { sizes, fontStyles, getButtonPadding } from "../../tokens/buttons";
import * as buttons from "../../tokens/buttons";
import { ButtonStyles } from "../../internalConstants";
export function createStyles(_ref) {
  var _objectSpread2;

  var appearance = _ref.appearance,
      size = _ref.size,
      stretch = _ref.stretch,
      hasIcon = _ref.hasIcon;
  var states = buttons[appearance === "default" ? "defaultState" : appearance];
  return _objectSpread(_objectSpread(_objectSpread({
    background: states.background,
    color: states.color,
    border: "1px solid ".concat(states.border),
    borderRadius: borderRadius.small,
    boxShadow: "none",
    cursor: "pointer"
  }, fontStyles[size]), {}, {
    fontWeight: fonts.weights.medium,
    margin: 0,
    position: "relative",
    textDecoration: "none",
    textAlign: "center",
    boxSizing: "border-box",
    overflow: "visible",
    textTransform: "none",
    transition: "\n    background-color ".concat(ButtonStyles.fastTransitionBehaviour, ",\n    color ").concat(ButtonStyles.transitionBehaviour, ",\n    border-color ").concat(ButtonStyles.transitionBehaviour, ",\n    box-shadow ").concat(ButtonStyles.transitionBehaviour, ",\n    fill ").concat(ButtonStyles.transitionBehaviour),
    outline: "none",
    userSelect: "none",
    whiteSpace: "nowrap",
    alignItems: "center",
    justifyContent: "center",
    height: sizes[size]
  }, getButtonPadding(appearance, size, hasIcon)), {}, (_objectSpread2 = {
    width: stretch ? "100%" : "auto",
    display: stretch ? "flex" : "inline-flex",
    "&:focus": {
      background: states.background,
      borderColor: states.border,
      color: states.focus.color
    }
  }, _defineProperty(_objectSpread2, "&.focus-visible", {
    zIndex: 1,
    background: states.focus.background,
    borderColor: states.focus.border,
    color: states.focus.color,
    boxShadow: "0 0 0 2px ".concat(states.focus.outline, ", 0 0 0 1px ").concat(states.focus.border, " inset")
  }), _defineProperty(_objectSpread2, "&:visited", {
    color: states.color,
    background: states.background
  }), _defineProperty(_objectSpread2, "&:hover", {
    background: states.hover.background,
    borderColor: states.hover.border,
    color: states.hover.color
  }), _defineProperty(_objectSpread2, "&:active", {
    background: states.active.background,
    borderColor: states.active.border,
    color: states.active.color,
    boxShadow: "0 0 0 1px ".concat(states.active.border, " inset")
  }), _defineProperty(_objectSpread2, "&[disabled], &[disabled]:hover", {
    color: states.disabled.color,
    opacity: 1,
    background: states.disabled.background,
    borderColor: states.disabled.border,
    cursor: "not-allowed"
  }), _objectSpread2));
}